export const TOP_BAR_HEIGHT = 60;

export const globalStyles = {
  toolTip: 10,
  topBar: 1,
  base: 0,
  boxedContainer: -1,
};
